<template>
  <div>
    <!--开启摄像头的弹窗-->
    <!-- <div class="info2" @click="onTake" v-if="imgFlag">
      <el-image
        :src="imgSrc"
        style="width: 148px; height: 148px; border-radius: 6px"
      ></el-image>
    </div> -->
    <div class="upImg hello" @click="onTake" v-if="type == 0">
      <i class="el-icon-camera" title="拍照"></i>
      <div class="cameraText">拍照上传</div>
    </div>
    <i class="el-icon-camera iconButton" v-else-if="type == 1" @click="onTake"></i>
    <!--开启摄像头的拍照和-->
    <el-dialog
      title="拍照上传"
      :visible.sync="visible"
      @close="onCancel1"
      width="1065px"
      :modal="false"
    >
      <div class="box">
        <video
          id="videoCamera"
          class="canvas"
          :width="videoWidth"
          :height="videoHeight"
          autoPlay
        ></video>
        <canvas
          id="canvasCamera"
          class="canvas"
          :width="videoWidth"
          :height="videoHeight"
        ></canvas>
      </div>
      <div slot="footer">
        <el-button @click="drawImage" icon="el-icon-camera" size="small" type="success" plain>
          拍照
        </el-button>
        <el-button
          v-if="os"
          @click="getCompetence"
          icon="el-icon-video-camera"
          size="small"
          type="success" plain
        >
          打开摄像头
        </el-button>
        <el-button
          v-else
          @click="stopNavigator"
          icon="el-icon-switch-button"
          size="small"
          type="success" plain
        >
          关闭摄像头
        </el-button>
        <el-button @click="resetCanvas" icon="el-icon-refresh" size="small" type="success" plain>
          重置
        </el-button>
        <el-button @click="onCancel" icon="el-icon-circle-close" size="small" type="success" plain>
          完成
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="tipsFlag"
      width="30%"
      :show-close="false"
      :close-on-click-modal="false"
      :modal="false"
      class="tipsMsgBox"
    >
      <span style="font-size: 20px; font-weight: 800">{{ tipsMsg }}</span>
    </el-dialog>
  </div>
</template>

<script>
import { imgUpload } from "@/api/index";
import { getImgUrl } from "@/utils/index";
import store from "@/store/store"
export default {
  name: "HelloWorld",
  props: {
    msg: String,
    type:Number
  },
  data() {
    return {
      url: "", // 上传的图片的地址
      visible: false, //弹窗
      videoWidth: 500, // 绘画布的宽高
      videoHeight: 400,
      os: false, //控制摄像头开关
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      imgSrc: undefined,
      imgFile: null,
      imgFlag: false,
      evImgURL: getImgUrl(),
      canvesFlag:false,
      tipsFlag:false,
      tipsMsg:"",
    };
  },
  methods: {
    /*调用摄像头拍照开始*/
    onTake() {
      if(store.state.StatusFlag){
        if(this.canvesFlag){
          this.resetCanvas();
        }
        this.visible = true;
        this.getCompetence();
      }else{
        this.tipsFlag = true;
        this.tipsMsg = "请在接诊后再上传图片";
        setTimeout(()=>{
          this.tipsFlag = false;
        },2000)
      }
    },

    /*关闭弹窗，以及关闭摄像头功能*/
    onCancel1() {
      this.visible = false;
      this.stopNavigator(); // 关闭摄像头
    },

    // 调用摄像头权限
    getCompetence() {
      //必须在model中render后才可获取到dom节点,直接获取无法获取到model中的dom节点
      this.$nextTick(() => {
        const _this = this;
        this.os = false; //切换成关闭摄像头
        // 获取画布节点
        this.thisCancas = document.getElementById("canvasCamera");
        // 为画布指定绘画为2d类型
        this.thisContext = this.thisCancas.getContext("2d");
        //获取video节点
        this.thisVideo = document.getElementById("videoCamera");
        // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        if (navigator.mediaDevices === undefined) {
          navigator.menavigatordiaDevices = {};
        }
        // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        // 使用getUserMedia，因为它会覆盖现有的属性。
        // 这里，如果缺少getUserMedia属性，就添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = function (constraints) {
            // 首先获取现存的getUserMedia(如果存在)
            let getUserMedia =
              navigator.webkitGetUserMedia ||
              navigator.mozGetUserMedia ||
              navigator.getUserMedia;
            // 有些浏览器不支持，会返回错误信息
            // 保持接口一致
            if (!getUserMedia) {
              return Promise.reject(
                new Error("getUserMedia is not implemented in this browser")
              );
            }
            // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
            return new Promise(function (resolve, reject) {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          };
        }
        const constraints = {
          audio: false,
          video: {
            width: _this.videoWidth,
            height: _this.videoHeight,
            transform: "scaleX(-1)",
          },
        };
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(function (stream) {
            // 旧的浏览器可能没有srcObject
            if ("srcObject" in _this.thisVideo) {
              _this.thisVideo.srcObject = stream;
            } else {
              // 避免在新的浏览器中使用它，因为它正在被弃用。
              _this.thisVideo.src = window.URL.createObjectURL(stream);
            }
            _this.thisVideo.onloadedmetadata = function (e) {
              _this.thisVideo.play();
            };
          })
          .catch((err) => {
            this.$notify({
              title: "警告",
              message: "没有开启摄像头权限或浏览器版本不兼容.",
              type: "warning",
            });
          });
      });
    },

    //调用摄像头 --- 进行绘制图片
    drawImage() {
      // 点击，canvas画图
      this.thisContext.drawImage(
        this.thisVideo,
        0,
        0,
        this.videoWidth,
        this.videoHeight
      );
      // 获取图片base64链接
      this.imgSrc = this.thisCancas.toDataURL("image/png");
      this.canvesFlag = true;
    },
    //清空画布
    clearCanvas(id) {
      let c = document.getElementById(id);
      let cxt = c.getContext("2d");
      cxt.clearRect(0, 0, c.width, c.height);
    },

    //重置画布
    resetCanvas() {
      this.clearCanvas("canvasCamera");
      this.imgSrc=""
    },

    //关闭摄像头
    stopNavigator() {
      if (this.thisVideo && this.thisVideo !== null) {
        this.thisVideo.srcObject.getTracks()[0].stop();
        this.os = true; //切换成打开摄像头
      }
    },
    /*调用摄像头拍照结束*/

    /*完成拍照并对其照片进行上传*/
    onCancel() {
      if(this.imgSrc != ""){
        this.visible = false;
        this.imgFile = this.dataURLtoFile(this.imgSrc, new Date() + ".png");
        this.stopNavigator();
        let data = new FormData();
        data.append("file", this.imgFile); //1是图片，2是视频
        let postData = {
          file: this.imgSrc,
        };
        // checkbeforepersonalphoto上传图片的接口
        imgUpload(postData).then((res) => {
          if (res.code == "0") {
            this.$message({
              message: "上传成功",
              type: "success",
            });
            this.url = res.data;
            this.imgFlag = true;
  
            let getImg = this.evImgURL+res.data
            store.commit("SET_GETIMG",this.imgSrc);
            store.commit("SET_COVER",res.data);
          }
        });
      }
    },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style scoped>
.hello {
  /* padding-top: 29px; */
  width: 104px;
  height: 102px;
}
.box {
  display: flex;
}
.upImg {
  position: relative;
  width: 104px;
  height: 102px;
  border: 1px dashed rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  color: #8c939d;
  cursor: pointer;
}
.upImg:hover {
  border-color: #0caf60;
  border-style: solid;
  color: #0caf60;
}
.upImg i {
  position: absolute;
  font-size: 28px;
  top: 26px;
  left: 36.3%;
}
.cameraText{
  position: absolute;
  top: 61px;
  left: 18.3%;
  text-align: center;
}
.iconButton {
  margin-right: 20px;
  font-size: 30px;
  cursor: pointer;
  color: #0caf60;
}
.iconButton:hover {
  color: #0caf60;
}
</style>
